import type {
  Ability,
  CharacterStats,
  MovementStats,
} from '../../CharacterTypes';

// Druid — nature caster + healer hybrid (single-identity MVP, no shapeshifting).
// Stat profile: genuinely balanced per the legacy [druid_classic] reference profile (str=80/agi=60/
// int=60/sta=80/spi=60), translated to H2000's shape as a caster-healer with
// moderate survivability (leather armor, not cloth). Intellect tilts high for
// spellcasting but not as extreme as Mage; defense/magicDefense sit between
// Mage and Paladin. HoT-leaning healing identity distinct from Priest (direct)
// and Shaman (burst chain).
export const DRUID_CONFIG = {
  name: 'Wildhearted',
  description: 'Nature caster and healer who mends allies with regenerative magic and commands the wrath of the wild',
  baseStats: {
    strength: 8,
    dexterity: 9,
    intelligence: 14,
    luck: 11,
    attack: 8,
    magicAttack: 22,
    defense: 9,
    magicDefense: 14,
    criticalRate: 0.07
  } as CharacterStats,
  healthMultiplier: 1.0,
  manaMultiplier: 1.2,
  color: '#6B8E23',
  movementStats: {
    jumpPower: 1050,
    targetJumpHeight: 200,
    moveSpeed: 280,
    gravityScale: 1.0,
    terminalVelocity: 1100,
    acceleration: 2750,
    deceleration: 6000
  } as MovementStats,
  abilities: [
    {
      id: 'druid_auto',
      name: 'Nature Bolt',
      damage: 10,
      manaCost: 0,
      cooldown: 600,
      lastUsed: 0,
      range: 500,
      castTime: 0,
      description: 'Basic nature-damage ranged auto attack.',
      icon: '/icons/abilities/druid_auto.svg'
    },
    {
      id: 'wrath',
      name: 'Wrath',
      damage: 30,
      manaCost: 12,
      cooldown: 1500,
      lastUsed: 0,
      range: 550,
      castTime: 0,
      description: 'Launch a bolt of nature energy at the enemy.',
      icon: '/icons/abilities/wrath.svg'
    },
    {
      id: 'rejuvenation',
      name: 'Rejuvenation',
      damage: 0,
      manaCost: 18,
      cooldown: 6000,
      lastUsed: 0,
      range: 0,
      castTime: 0,
      description: 'Heal over time — regenerates health every 3 seconds for 12 seconds.',
      icon: '/icons/abilities/rejuvenation.svg'
    },
    {
      id: 'healing_touch',
      name: 'Healing Touch',
      damage: 0,
      manaCost: 30,
      cooldown: 8000,
      lastUsed: 0,
      range: 0,
      castTime: 1500,
      description: 'A large direct heal that restores a burst of health.',
      icon: '/icons/abilities/healing_touch.svg'
    },
    {
      id: 'entangling_roots',
      name: 'Entangling Roots',
      damage: 10,
      manaCost: 20,
      cooldown: 12000,
      lastUsed: 0,
      range: 400,
      castTime: 0,
      description: 'Root the target in place with grasping vines, slowing movement.',
      icon: '/icons/abilities/entangling_roots.svg'
    },
    {
      id: 'barkskin',
      name: 'Barkskin',
      damage: 0,
      manaCost: 25,
      cooldown: 30000,
      lastUsed: 0,
      range: 0,
      castTime: 0,
      description: 'Skin hardens like bark, absorbing incoming damage for 10 seconds.',
      icon: '/icons/abilities/barkskin.svg'
    }
  ] as Ability[]
};
